import './App.css';
import { useEffect, useRef, useLayoutEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ScrollSmoother from 'gsap/ScrollSmoother';
import { useState } from 'react';
import DOMPurify from 'dompurify';
import MainPoint from './mainPoint';
import Header from './header';
import Overview from './overview';
import ColumnLayout from './columnLayout';
import Hundred from './hundred';
import Dissipate from './dissipate';
import Temperature from './temperature';
import Rgb from './rgb';
import SwiperChangeLayout from './swiperChangeLayout/swiperChangeLayout';
import Parts from './parts';
import Id from './id';
import Battery from './battary';
gsap.registerPlugin(ScrollTrigger);
// ScrollTrigger.normalizeScroll(true);

let language = document.querySelector('meta[name="language"]').content;
document.getElementById('root').setAttribute('lang', language);
let json =
  language === 'cn'
    ? {
        text1: '五倍百瓦棒灯',
        text2: '观看视频',
        text3:
          '以持续科技创新，革新传统结构设计，带来轻便“百瓦棒灯”新标杆；集成多通路供电技术，让创作恒久发光，用科技想象不断启发每一份创作想象。',
        text4: '<div class="mainText">100W</div>大功率',
        text5: '专业<div class="mainText">双色温</div>',
        text6: '高亮<div class="mainText">RGB</div>',
        text7: '情景<div class="mainText">光效</div>',
        text8: 'SOS',
        text9: '电视机',
        text10: '坏灯泡',
        text11: '蜡烛',
        text12: '闪电',
        text13: '火焰',
        text14: '智云五倍 F100',
        text15: '仅有950g',
        text16: '切换黑色款',
        text17: '切换白色款',
        text18: '无需繁琐设置和装配',
        text19: '取出就能轻松控光补光',
        text20: '简约设计融合出色质感',
        text21: '带来舒适单手操控感受',
        text22: '大功率<br /><div class="mainText">让创作发光</div>',
        text23:
          '密集灯珠排列，近5倍的灯珠排布数量，同样体积光源面积更大更亮。千分级精密电调技术，<div class="mainText">调光效率提高至90%以上</div>，保障稳定输出高亮光源，<div class="mainText">峰值照度可达20708Lux。</div>',
        text24:
          '* 照度数值为0.3m距离，100%亮度输出测试环境所得；MAX模式为全功率输出模式，4000K最大功率为100W，进入该模式后调整至100%为各色温下的最大输出功率。',
        text25: '智云<br /><div class="mainText">散热技术</div>',
        text26:
          '采用电子回压系统，引入陀螺仪变量精密建模设计散热器和6个FOC变频风扇，优化散热片工艺，动态理顺内部气流，大幅提高气流排量，<div class="mainText">同等体积和质量下，保证近5倍的散热效率。支持主动散热，智能控温和高温保护</div>，出色结构让小体积空间也能释放强劲性能。',
        text27: '* 使用智云五倍F100超过一定温度时将自动开启风扇散热。',
        text28: 'CCT模式<br />专业<div class="mainText">双色温</div>',
        text29: '一键快速切换模式，转盘调节各类参值，专业表现不错过每分光影。',
        text30: 'CCT范围',
        text31: '2700-6200K',
        text32: 'CRI',
        text33: '≧96',
        text34: 'TLCI',
        text35: '≧97',
        text36: 'HSI模式<br /><div class="mainText">高亮RGB</div>',
        text37:
          'RGB灯珠增加至148颗，亮度较前代提升1倍以上，亮出氛围，秀出创意。',
        text38: '色相 H',
        text39: '0-360°',
        text40: '色彩饱和度 S',
        text41: '0-100%',
        text42: '亮度 I',
        text43: '0-100%',
        text44: '<div class="mainText">情景光效</div><br />创意加电',
        text45:
          '<div class="mainText">内置6种情景光效和多类氛围光效</div>，可精准控制每颗灯珠的开关、亮度和色彩，串联不同灯珠效果实现光剑、流动渐变、双轨道流星等特效灯光。',
        text46: '塑光有型<br /><div class="mainText">控光随心</div>',
        text47:
          '加入<div class="mainText">柔光布、挡光板、控光格栅和出行便携收纳包</div>，控光更便携专业，补光很有型。在直播、人物特写、采访、静物拍摄、TVC和VLOG记录中，都能带来绝佳表现。',
        text48: '* 以上控光附件需购买套装版或单独购买使用。',
        text49: '创作不停电<br /><div class="mainText">3种供电方案</div>',
        text50:
          '使用自适应充电技术，可根据不同功率的PD充电适配器，充分均衡高功率和长续航拍摄需求。<div class="mainText">支持不同功率下边使用边动态充电，电池峰值充电功率达25W。</div>内置6颗2600mAh电池，纯电池供电状态下，<div class="mainText">50W大功率使用也能实现1H 4min长续航。</div>',
        text51:
          '* 100W PD快充可实现电源直供峰值大功率补光；CCT等常规功率模式使用，可另外为内置电池充电。120W电源适配器需单独购买。10W功率可持续输出5h40min，25W功率可持续输出2h10min ，全功率100W可持续输出31min，以上数据为智云实验室环境测试所得，实际使用略有差异。',
        text52: '支持Type-C',
        text53: 'PD快充',
        text54: '支持DC充电',
        text55: '120W',
        text56: '支持',
        text57: '边充边用',
      }
    : {
        text1: '100W Stick Light',
        text2: 'Watch Video',
        text3:
          'Through unremitting technology development and accumulation, ZHIYUN introduces the F100, a new benchmark of portable stick lights. The integration of 100W high power and great performance achieved by innovative technologies enlivens every detail of your creation.',
        text4: '<div class="mainText">100W</div> High Power',
        text5:
          'Professional <div class="mainText">Dual Color Temperature</div>',
        text6: 'Pro <div class="mainText">RGB</div>',
        text7: 'Special <div class="mainText">Light Effects</div>',
        text8: 'SOS',
        text9: 'TV',
        text10: 'Faulty Bulb',
        text11: 'Candle',
        text12: 'Flash',
        text13: 'Fire',
        text14: 'ZHIYUN FIVERAY F100',
        text15: 'Only 950g',
        text16: 'Switch to black type',
        text17: 'Switch to white type',
        text18: 'No complex setups',
        text19: 'Your portable lighting on the go',
        text20: 'Minimalist Design & Rich Features',
        text21: 'Fits perfectly in your hand',
        text22:
          'Brighter<br /><div class="mainText">with 100W High Power</div>',
        text23:
          'Embedded with 5 times more LED chips, F100 gives you ultra-bright output compared to the same-sized lights. The highly sophisticated technology firmly <div class="mainText">improves the lighting control efficiency up to over 90%</div>, ensuring a stable illuminance that can <div class="mainText">reach 20708 lux at its peak</div>.',
        text24:
          '*The above data is gathered when the brightness level is set at 100% and the test distance is 0.3m. The MAX mode is the full power mode. The peak power output in 4000K is 100W. Under the MAX mode, when the brightness level is 100%, the power output reaches its peak.',
        text25: 'Innovative<br /><div class="mainText">Cooling System</div>',
        text26:
          'F100 adopts inventive DynaVort Cooling System™ based on fluid dynamics and the dynamic algorithm. The cooling system consists of gyroscope modeling heat sinks and 6 FOC fans to prevent overheating, <div class="mainText">raising the cooling efficiency to 5 times higher by substantially enhancing the airflow emissions with intelligent control</div>.',
        text27:
          '*The fans are enabled automatically when the power exceeds a certain level.',
        text28:
          'CCT Mode<br />for <div class="mainText">Brilliant Rendition</div>',
        text29:
          'F100 offers precise adjustment of color temperature in CCT Mode via the intuitive dial. The industry-standard CRI and TLCI bring your story to life effortlessly and authentically.',
        text30: 'CCT Range',
        text31: '2700-6200K',
        text32: 'CRI',
        text33: '≧96',
        text34: 'TLCI',
        text35: '≧97',
        text36: 'HSI Mode<br /><div class="mainText">Pro RGB</div>',
        text37:
          'RGB chips increased to 148, improving the lighting effect two times brighter than the predecessor, giving you sturdy support for more possibilities.',
        text38: 'Hue',
        text39: '0-360°',
        text40: 'Saturation',
        text41: '0-100%',
        text42: 'Intensity',
        text43: '0-100%',
        text44: 'Let Your<br />Creativity <div class="mainText">Shine</div>',
        text45:
          '<div class="mainText">Provide you with six creative lighting effects and various ambient lighting</div> that help build up atmosphere easily when inspiration strikes.',
        text46:
          'Get <div class="mainText">Intuitive and<br />Precise</div> Control ',
        text47:
          'Offer multiple accessories including <div class="mainText">storage bag, 2-leaf barn doors, diffuser and grid</div> for more professional lighting. Get ready to nail every shoot in various scenarios such as livestreaming, interviews, TVC, vlogging, and close-up portraits.',
        text48:
          '* The above accessories are only included in the Combo package or sold separately.',
        text49: 'Inspiration Glows<br /><div class="mainText">Non-Stop</div>',
        text50:
          'The adaptive charging technology makes F100 compatible with PD power adapters of different power, satisfying the need for both high power and long runtime. With the switching adapter, <div class="mainText">you can continuously use FIVERAY F100 at different power while charging it. Peak charging power of batteries reaches 25W</div>. 6 built-in 2600mAh batteries ensure <div class="mainText">1-hour-4-min runtime at 50W working power</div>. ',
        text51:
          "*You can use F100 at max power while charging it via the 100W PD fast charger. When it's used at the normal power such as in the CCT mode, the built-in batteries are charged in the meantime. The 120W power adapter is not included in the standard package. The F100 works for 5h40min at 10W, 2h10min at 25W, and 31min at the 100W max power. The above data is gathered from internal experiments of ZHIYUN laboratories. Please refer to the actual use.",
        text52: 'Supports Type-C',
        text53: 'PD Fast Charging',
        text54: 'Supports DC Charging',
        text55: '120W',
        text56: 'Supports',
        text57: 'Charging while Using',
      };

function is_weixin() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  } else {
    return false;
  }
}

let isWeiXin = is_weixin();

function App() {
  const [textData, setTextData] = useState(json);
  const smoother = useRef(null);

  useEffect(() => {
    async function fetchData() {
      let response = await fetch(
        `https://www.zhiyun-tech.com/website/in18/f100/${language}.json`,
      );
      if (response.ok) {
        let json = await response.json();
        function formatText(text) {
          if (text.indexOf('{') < 0 && text.indexOf('_') < 0) {
            return text;
          } else if (text.indexOf('{') >= 0) {
            let rightBrackets = text.indexOf('{');
            let leftBrackets = text.indexOf('}') + 1;
            let oldText = text.slice(rightBrackets, leftBrackets);
            let newText = `<div class="mainText">${text.slice(
              rightBrackets + 1,
              leftBrackets - 1,
            )}</div>`;

            return formatText(text.replace(oldText, newText));
          } else if (text.indexOf('_') >= 0) {
            let brackets = text.indexOf('_');
            let oldText = text.slice(brackets, brackets + 1);
            let newText = `<br />`;
            return formatText(text.replace(oldText, newText));
          }
        }

        for (let item in json) {
          json[item] = formatText(json[item]);
        }
        console.log(json);
        setTextData(json);
      } else {
        console.log('HTTP-Error: ' + response.status);
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    document.querySelectorAll('[data-fade-in-play="true"]').forEach((item) => {
      ScrollTrigger.create({
        trigger: item,
        start: 'top 50%',
        onEnter: () => {
          if (item.played.length === 0) {
            item.play();
          }
        },
      });
    });
  }, []);

  return (
    <div className="App">
      <Header textData={textData} language={language} />
      <Overview textData={textData} language={language}/>
      <MainPoint textData={textData} language={language}/>
      <SwiperChangeLayout
        style={{
          '--theme-color': '#FF6666',
        }}
        title={textData['text44']}
        body={textData['text45']}
        content={[
          {
            mediaType: 'video',
            src: `http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/fiverayf100/f100-video-lighteffect-01${language === 'cn' ? '' : '-en'}.mp4`,
            poster:
              `http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/fiverayf100/f100-video-lighteffect-01-cover${language === 'cn' ? '' : '-en'}.jpg`,
            text: DOMPurify.sanitize(textData['text9']),
          },
          {
            mediaType: 'video',
            src: `http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/fiverayf100/f100-video-lighteffect-02${language === 'cn' ? '' : '-en'}.mp4`,
            poster:
              `http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/fiverayf100/f100-video-lighteffect-02-cover${language === 'cn' ? '' : '-en'}.jpg`,
            text: DOMPurify.sanitize(textData['text12']),
          },
          {
            mediaType: 'video',
            src: `http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/fiverayf100/f100-video-lighteffect-03${language === 'cn' ? '' : '-en'}.mp4`,
            poster:
              `http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/fiverayf100/f100-video-lighteffect-03-cover${language === 'cn' ? '' : '-en'}.jpg`,
            text: language === 'cn' ? DOMPurify.sanitize(textData['text11']) : DOMPurify.sanitize(textData['text10']),
          },
        ]}
      />
      <Id textData={textData} language={language}></Id>
      <Hundred textData={textData} language={language}></Hundred>
      <Dissipate textData={textData} language={language}/>
      <Temperature textData={textData} language={language}/>
      <Rgb textData={textData} language={language} />
      <Parts textData={textData} language={language}/>
      <Battery textData={textData} language={language}/>
    </div>
  );
}

export default App;
